import { Component, ElementRef, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';

import { TournamentsService } from './../tournaments/services/tournaments.service';
import { DomSanitizer } from '@angular/platform-browser';
import { translationHelper } from '~/helpers/translation.helper';
import { sportradarStats } from '@env/environment';
import { AppComponentBase } from '~/shared/app-component-base';

declare let $;
declare let SetLanguage: any;
@Component({
    selector: 'comp_results_modal',
    templateUrl: './results_modal.html',
})
export class ResultsModal extends AppComponentBase implements OnInit {
    public init: boolean;

    iframesrc;

    constructor(
        public tournamentsService: TournamentsService,
        private domSanitizer: DomSanitizer,
        private _translationHelper: translationHelper,
        private _injector: Injector,
    ) {
        super(_injector);
    }
    public ngOnInit() {
        if (this.init) {
            return;
        }
        this.init = true;

        let url = '';

        url = this.getLiveScorePage(this._translationHelper.LANGCODE);

        this.iframesrc = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
    public ResultsModal_Close() {
        $('#ResultModal').modal('hide');
    }

    getLiveScorePage = LangId => {
        return sportradarStats + LangId;
    };

    public getBGColorResulModal(i) {
        if (i % 2 === 0) {
            return '#333333';
        } else {
            return '#111111';
        }
    }
    public Result_downScroll() {
        $('#resultList').animate(
            {
                scrollTop: '+=100',
            },
            300,
            'swing',
        );
    }
    public Result_upScroll() {
        $('#resultList').animate(
            {
                scrollTop: '-=100',
            },
            300,
            'swing',
        );
    }
}
